import { PaginationResponse } from '@/main/models/common/paginationResponse';
import { Result } from '@/main/models/common/resultResponse';
import { ReportTemplateHistoricalRequest } from '@/main/models/request';
import { ReportTemplateHistoricalResponse } from '@/main/models/response';
import { ApiHistoryItem } from '@/main/models/response/apiHistoryItem';
import { AxiosResponse } from 'axios';

export abstract class IReportTemplateHistoricalApi {
  abstract getHistoric(
    request: ReportTemplateHistoricalRequest
  ): Promise<
    AxiosResponse<PaginationResponse<ReportTemplateHistoricalResponse>>
  >;

  abstract getDetailHistoric(
    guidHistorical: string
  ): Promise<AxiosResponse<Result<ApiHistoryItem[]>>>;
}

